import { Bars3Icon } from '@heroicons/react/24/outline';
import React from 'react';

const Hamburger: React.FC = props => (
  <Bars3Icon className="h-8 w-8 text-green-500" strokeWidth={2} />
);

export default Hamburger;
